import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import PhoneInput from "react-phone-input-2";

import {
  AiFillPlusCircle,
  AiOutlineCloseCircle,
  AiOutlinePlus,
} from "react-icons/ai";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { RiDeleteBinLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import editIcon from "../../assets/icons/Group2694.svg";
import lockBlue from "../../assets/icons/lockBlue.svg";
import lockGrey from "../../assets/icons/lockGrey.svg";
import SupplierHeader from "../../layouts/SupplierHeader";
import Loader from "../../components/Dailogs/Loader";
import {
  AddDocToSupplier,
  AddSupplier,
  DeleteDocs,
  FetchDocsSupplierById,
  FetchSearchSupplier,
  FetchSuppliertById,
  UpdateIslocked,
  UpdateSupplier,
  fetchTranslationData,
  UpdateSupplierContactIndexPositions,
  SupplierEmailValidation,
} from "../../redux/actions/action";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import { API_URL, UPDATE_SUPPLIER } from "../../redux/constants/type";
import "../../assets/styles/local/Addsupplier.css";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import AddIcon from "../../assets/icons/addicon.svg";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import DocumentUploaderWithProgress from "../../components/Common/Document_Uploader_With_Progress";
import roundFileSize from "../../utils/Documents/roundFileSize";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { EyeOutlined } from "@ant-design/icons";
import { getFilePreview } from "../../utils/filePreview/filePreview";
import FilePreviewModal from "../../utils/filePreview/FilePreviewModal";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const Addsupplier = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const dropId = uuidv4();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const emailInputRefs = useRef([]);

  const [removeaddbtn, setRemoveaddbtn] = useState(false);

  const addsupplierresponse = useSelector((state) => state.user.AddSupplier);
  const supplierEmailExistOrNotRes = useSelector(
    (state) => state.user.supplierEmailExistOrNotRes,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const deletedocResponsedata = useSelector(
    (state) => state?.user?.DeleteDocsdata,
  );
  const UpdateSupplierResponse = useSelector(
    (state) => state.user.UpdateSupplierdata,
  );
  const singleContactResponse = useSelector(
    (state) => state.user.FetchSupplierById,
  );
  const AddDocTosupplierRES = useSelector(
    (state) => state.user.AddDocToSupplierData,
  );
  const docsSupplierListResponse = useSelector(
    (state) => state.user.FetchDocsSupplierByIdData,
  );
  const searchSupplierResponse = useSelector(
    (state) => state.user.FetchSearchSupplierdata,
  );
  const firstupname = window.localStorage.getItem("firstname");
  const lastupname = window.localStorage.getItem("lastname");
  const userId = window.localStorage.getItem("userid");
  const [popups, setPopups] = useState(false);
  const [supplierExistPopup, setSupplierExistPopup] = useState(false);
  const [Touched, setTouched] = useState(false);
  const [primaryColor, setPrimaryColor] = useState(
    window.localStorage.getItem("primarycolor"),
  );
  const [activeHeading, setActiveHeading] = useState("1");
  const [docAdded, setDocAdded] = useState(false);
  const selectDoc = useRef(null);
  const selectDragdoc = useRef(null);
  const [showDropPeople, setShowDropPeople] = useState(false);
  const companyId = window.localStorage.getItem("companyId");
  const [isUpdating, setIsUpdating] = useState(false);
  const [docPeopleList, setDocPeopleList] = useState([]);
  const [contactDocsList, setContactDocsList] = useState([]);
  const [docAccessList, setDocAccessList] = useState([]);
  const [searchPeople, setSearchPeople] = useState("");
  ///////////////////////////////DATA VALUES STATE///////////////////////////////
  const roleId1 = window.localStorage.getItem("roleid");
  const [roleId, setRoleId] = useState("");
  const [showSupplierBox, setShowSupplierBox] = useState(false);
  const [fileName, setFileName] = useState("");
  const [mailError, setMailError] = useState({});
  const [errorfull, setErrorfull] = useState(false);
  const [fulLenghtDocAddContact, setFulLenghtDocAddContact] = useState(false);
  const [contectDoc, setContectDoc] = useState(
    window.localStorage.getItem("Doc"),
  );

  const [filePreview, setFilePreview] = useState(null);

  const [deleteRowIndex, setDeleteRowIndex] = useState(null);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const [deleteDocument, setDeleteDocument] = useState(false);
  const [Dragfilepage, setDragfilepage] = useState(false);
  const [validemail, setValidemail] = useState(false);
  const [SerchSupplierData, setSearchSupplierData] = useState([]);
  const [loadSwitchsupplier, setLoadSwitchsupplier] = useState(false);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [isTypeEmail, setIsTypeEmail] = useState(false);
  const [website, setWebsite] = useState("");
  const [suppliername, setSuppliername] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [address, setAddress] = useState("");
  const [iban, setIban] = useState("");
  const [paymentconditions, setPaymentconditions] = useState("");
  const [notes, setNotes] = useState("");
  const [vatNumber, setvatNumber] = useState("");
  const [supplierContact, setSupplierContact] = useState([
    {
      contactName: "",
      contactEmail: "",
      contactPhonenumber: "",
    },
  ]);
  const [headerscreenname, setheaderscreen] = useState("Supplier");

  const [supplierfilterid, setsupplierfilterid] = useState();
  const refSupplierDropdownContainer = useRef();

  useEffect(() => {
    fetchScreenTranslations("Add Suppliers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (searchSupplierResponse?.status === 200) {
      setShowSupplierBox(false);
      if (searchSupplierResponse != null) {
        const searchData = searchSupplierResponse?.data?.data;
        // Check if SearchSupplierData is empty
        if (searchData && searchData?.length > 0 && suppliername) {
          setSearchSupplierData(searchData);
          setShowSupplierBox(true); // Show the box when data is available
        } else {
          setSearchSupplierData([]); // Clear the data
          setShowSupplierBox(false); // Close the box when data is empty
        }
      }
    }
  }, [searchSupplierResponse]);
  const handleDeleteDocumentFun = () => {
    if (
      !deleteRowData?.islocked &&
      (deleteRowData?.userId === userId ||
        deleteRowData?.islockedby?.userid === userId ||
        roleId1 === process.env.REACT_APP_IS_OWNER)
    ) {
      setTouched(true);

      const updatedRecords = [...paginationObj1?.records];
      updatedRecords.splice(deleteRowIndex, 1);

      if (deleteRowData?.documentid) {
        dispatch(DeleteDocs(deleteRowData?.documentid));
      }

      setPaginationObj1((prevPaginationObj) => ({
        ...prevPaginationObj,
        totalRecords: prevPaginationObj.totalRecords - 1,
        records: [...updatedRecords],
      }));

      setContactDocsList((prevContactDocsList) => {
        const updatedContactDocsList = [...prevContactDocsList];
        updatedContactDocsList.splice(deleteRowIndex, 1);
        return updatedContactDocsList;
      });
    }

    setDeleteDocument(false);
    setDeleteRowData(null);
    setDeleteRowIndex(null);
  };

  useEffect(() => {
    if (contectDoc) {
      setActiveHeading("3");
      // setDocAdded(true);
      setTimeout(() => {
        window.localStorage.removeItem("Doc");
        setContectDoc(null);
      }, 1000);
    }
  }, [contectDoc]);

  useEffect(() => {
    if (showSupplierBox) {
      window.addEventListener("mousedown", handleMouseDownCompanyDD);
    } else {
      window.removeEventListener("mousedown", handleMouseDownCompanyDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownCompanyDD);
    };
  }, [showSupplierBox]);

  const handleMouseDownCompanyDD = (event) => {
    if (
      refSupplierDropdownContainer.current &&
      !refSupplierDropdownContainer.current.contains(event.target)
    ) {
      setShowSupplierBox(false);
    }
  };
  const customStyles = {
    container: {
      border: "1px solid #ccc",
      borderRadius: "4px",
      width: "100%",
    },
    input: {
      width: "100%",
      padding: "10px",
      fontSize: "16px",
      border: "none",
      boxSizing: "border-box",
    },
  };
  useEffect(() => {
    if (path.includes(`/supplierlist/add-supplier/${id}`)) {
      if (singleContactResponse?.status === 200) {
        const contactObject = singleContactResponse?.data?.data[0];
        setSuppliername(contactObject.suppliername);
        setEmail(contactObject.email);
        setPhonenumber(contactObject.phonenumber);
        // setAddress(contactObject.address);
        // setvatNumber(contactObject.vatNumber);
        // setIban(contactObject.iban);
        // setWebsite(contactObject.website);
        // setPaymentconditions(contactObject.paymentconditions);
        // setNotes(contactObject.notes);
        // setSupplierContact(contactObject.suppliercontact);
      }
    }
  }, [singleContactResponse]);

  useEffect(() => {
    if (path.includes(`/supplierlist/add-supplier/${id}`)) {
      setLoadSwitchsupplier(true);
    }
  }, [path]);

  useEffect(() => {
    if (AddDocTosupplierRES?.status === true) {
      dispatch(FetchDocsSupplierById(id));
    } else {
      return;
    }
  }, [AddDocTosupplierRES]);

  const onFileUploaded = (data) => {
    if (isUpdating) {
      let reqArray = [];
      reqArray.push({
        documentname: data[0].name,
        documentextension: data[0].type,
        documentcontent: "string",
        link: data[0].link,
        documentsize: data[0].size,
        islocked: 0,
        uploadedbyfirstname: firstupname,
        uploadedbylastname: lastupname,
        userId: roleId1,
      });
      dispatch(AddDocToSupplier(id, reqArray));
    } else {
      const modifiedContacts = contactDocsList;
      modifiedContacts.push({
        documentname: data[0].name,
        documentextension: data[0].type,
        documentcontent: "string",
        link: data[0].link,
        documentsize: data[0].size,
        islocked: 0,
        uploadedbyfirstname: firstupname,
        uploadedbylastname: lastupname,
        userId: roleId1,
      });
      setContactDocsList([...modifiedContacts]);
    }
    setContectDoc("Doc");
    setTouched(true);
  };
  const docUploadDragfile = async (file) => {
    const filedata = file[0];
    // const target = file.target.files[0];
    // ;
    const filesizecontvrt = filedata?.size / 1024;
    if (filesizecontvrt / 1024 > 100) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "The File is too big: Upload a file of max 100 MB.",
        },
        false,
      );
    } else {
      handleGeneralNotification(
        { notificationType: "CUSTOM", text: "Your document is loading" },
        false,
      );
    }

    var formData = new FormData();
    formData.append("", file);
    let newfiles = filedata;
    let size = newfiles.size;
    let mbformatfile;
    if (size < 1024) {
      mbformatfile = size + " BYTE";
      // setFilesize(size + ' BYTE')
    } else if (size < 1024 * 1024) {
      mbformatfile = (size / 1024).toFixed(2) + " KB";
      // setFilesize((size / 1024).toFixed(2) + ' KB')
    } else {
      mbformatfile = (size / (1024 * 1024)).toFixed(2) + " MB";

      // setFilesize((size / (1024 * 1024)).toFixed(2) + ' MB')
    }

    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response !== null) {
        // if (filelist[0]?.documentsize < 102400) {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: "Document Uploaded successfully!",
          },
          false,
        );
        if (isUpdating) {
          let reqArray = [];
          reqArray.push({
            documentname: newfiles.name,
            documentextension: newfiles.type,
            documentcontent: "string",
            link: response.data[0],
            documentsize: mbformatfile,
          });
          setTimeout(() => {
            dispatch(AddDocToSupplier(id, reqArray));
          }, 1000);
        } else {
          const modifiedContacts = contactDocsList;
          modifiedContacts.push({
            documentname: newfiles.name,
            documentextension: newfiles.type,
            documentcontent: "string",
            link: response.data[0],
            documentsize: mbformatfile,
          });
          // setFilelist([...modifiedContacts]);
          setContactDocsList([...modifiedContacts]);
        }
        setContectDoc("Doc");
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (path.includes(`/supplierlist/edit-supplier/${id}`)) {
      if (docsSupplierListResponse.status === 200) {
        setContactDocsList(docsSupplierListResponse?.data?.data);
      }
    }
  }, [docsSupplierListResponse]);

  const [disableButton, setDisableButton] = useState(false);

  const handlesupplierAdd = () => {
    if (disableButton === true) return;
    if (isValueExists === true) return;

    setTouched(false);

    setRemoveaddbtn(true);
    const emailPattern = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;

    if (suppliername === "" && email === "") {
      setErrorfull(true);
      setValidemail(true);
    } else if (suppliername === "") {
      setErrorfull(true);
      setValidemail(false);
    } else if (email === "") {
      setErrorfull(false);
      setValidemail(true);
    } else if (!emailPattern.test(email)) {
      setErrorfull(false);
      setValidemail(true);
    } else {
      if (isUpdating && !Object.values(mailError).includes(true)) {
        setDisableButton(true);
        dispatch(
          UpdateSupplier(
            id,
            suppliername,
            email,
            phonenumber,
            address,
            vatNumber,
            iban,
            website,
            paymentconditions,
            notes,
            supplierContact.filter(
              (item) =>
                item.contactName.trim() !== "" ||
                item.contactEmail.trim() !== "" ||
                item.contactPhonenumber.trim() !== "",
            ),
          ),
        );
      } else {
        if (suppliername !== "" || email !== "") {
          if (!Object.values(mailError).includes(true)) {
            setDisableButton(true);
            dispatch(
              AddSupplier(
                suppliername,
                email,
                phonenumber,
                address,
                vatNumber,
                iban,
                website,
                paymentconditions,
                notes,
                supplierContact.filter(
                  (item) =>
                    item.contactName.trim() !== "" ||
                    item.contactEmail.trim() !== "" ||
                    item.contactPhonenumber.trim() !== "",
                ),
              ),
            );
          }
        } else {
          history.goBack();
          // history.push("/supplier-list");
        }
        // window.localStorage.removeItem("clientaddname");
        // window.location.reload("/supplier-list");
        // history.push("/supplier-list");
      }
    }
    // window.localStorage.removeItem("_tmpCon");
  };

  useEffect(() => {
    if (addsupplierresponse?.status === 200) {
      // handleGeneralNotification({ notificationType: "CUSTOM", text: "Contact Added successfully" }, false)
      let reqArray = [];
      contactDocsList?.forEach((elements) => {
        reqArray.push({
          documentname: elements?.documentname,
          documentextension: elements?.documentextension,
          documentcontent: elements?.documentcontent,
          link: elements?.link,
          documentsize: elements?.documentsize.toString(),
        });
      });
      if (reqArray.length > 0) {
        dispatch(
          AddDocToSupplier(
            addsupplierresponse?.data?.data?.supplierid,
            reqArray,
          ),
        );
      }
      dispatch({ type: "ADD_SUPPLIER", data: {} });
      setTimeout(() => {
        // history.push("/supplier-list");
        history.goBack();
      }, 1000);

      localStorage.setItem(
        "newSupplierData",
        JSON.stringify({
          supplierid: addsupplierresponse?.data?.data?.supplierid,
          suppliername: addsupplierresponse?.data?.data?.suppliername,
        }),
      );
    }
  }, [addsupplierresponse]);

  useEffect(() => {
    if (UpdateSupplierResponse.status === 200) {
      // handleGeneralNotification({ notificationType: "CUSTOM", text: "Contact Updated successfully" }, false)
      dispatch({ type: UPDATE_SUPPLIER, data: {} });
      setTimeout(() => {
        history.push("/supplier-list");
      }, 1000);
    }
  }, [UpdateSupplierResponse]);

  // useEffect(() => {
  //   if (deletedocResponsedata?.status === 200) {
  //     dispatch(FetchDocsSupplierById(id));
  //   } else {
  //     return;
  //   }
  // }, [deletedocResponsedata]);

  useEffect(() => {
    if (id) {
      dispatch(FetchSuppliertById(id))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
      dispatch(FetchDocsSupplierById(id));
      window.localStorage.setItem("active-supplier", id);
      // checkIfTempData();
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [id]);

  const checkIfTempData = () => {
    const tmpData = window.localStorage.getItem("_tmpCon");
    if (tmpData) {
      const jsonData = JSON.parse(tmpData);
      setSuppliername(jsonData.suppliername);
      setEmail(jsonData.email);
      setPhonenumber(jsonData.phonenumber);
      setAddress(jsonData.address);
      setvatNumber(jsonData.vatNumber);
      setIban(jsonData.iban);
      setWebsite(jsonData.website);
      setPaymentconditions(jsonData.paymentconditions);
      setNotes(jsonData.notes);
      setSupplierContact(jsonData.suppliercontact);
      window.localStorage.removeItem("_tmpCon");
    }
  };

  useEffect(() => {
    if (path.includes(`/supplierlist/edit-supplier/${id}`)) {
      if (singleContactResponse && singleContactResponse.status === 200) {
        const contactObject = singleContactResponse?.data?.data[0];
        setSuppliername(contactObject.suppliername);
        setEmail(contactObject.email);
        setPhonenumber(contactObject.phonenumber);
        setAddress(contactObject.address);
        setvatNumber(contactObject.vatNumber);
        setIban(contactObject.iban);
        setWebsite(contactObject.website);
        setPaymentconditions(contactObject.paymentconditions);
        setNotes(contactObject.notes);
        // setSupplierContact(contactObject.suppliercontact);
        setSupplierContact([
          ...contactObject.suppliercontact,
          { contactName: "", contactEmail: "", contactPhonenumber: "" },
        ]);

        // setClientId(contactObject?.contactclients[0]?.clientid);
        setIsUpdating(true);
        checkIfTempData();
      }
    }
  }, [singleContactResponse]);

  const handelCancel = () => {
    if (isUpdating === true) {
      if (
        suppliername !== "" ||
        email !== "" ||
        phonenumber !== "" ||
        supplierContact !== ""
      ) {
        if (Touched) {
          setPopups(true);
        } else {
          history.push("/supplier-list");
        }
      } else {
        history.push("/supplier-list");
      }
    } else {
      if (
        suppliername != "" &&
        email != "" &&
        phonenumber != "" &&
        supplierContact != ""
      ) {
        history.push("/supplier-list");
      } else {
        if (Touched) {
          setPopups(true);
        } else {
          // history.push("/supplier-list");
          history.goBack();
        }
      }

      // history.push("/supplier-list");
      // window.localStorage.removeItem("clientaddname");
    }
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      // backgroundColor: theme.palette.common.white,
      fontWeight: 400,
      color: "#333333",
      fontSize: "14px",
      background: "#F1F1F1 0% 0% no-repeat padding-box",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
    },
  }));

  const handleDownloadContact = (event, documentid, documentname) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
    });
  };
  useEffect(() => {
    // Initialize mailError state based on the length of supplierContact
    setMailError((prevErrors) => {
      const newErrors = { ...prevErrors };
      for (let i = 0; i < supplierContact.length; i++) {
        newErrors[i] = false; // or true based on your initial validation logic
      }
      return newErrors;
    });
  }, [supplierContact?.length]);

  const handleInputChange = (index, field, value) => {
    setTouched(true);
    const newInputs = [...supplierContact];
    newInputs[index][field] = value;
    if (field === "contactEmail") {
      const emailPattern = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;
      const isEmailValid = value.trim() !== "" && emailPattern.test(value);
      setMailError((prevErrors) => ({
        ...prevErrors,
        [index]: !isEmailValid,
      }));
    }
    //  else if (field === "contactPhonenumber") {
    //   if (index === newInputs.length - 1 && value !== "") {
    //     newInputs.push({
    //       contactName: "",
    //       contactEmail: "",
    //       contactPhonenumber: "",
    //     });
    //   }
    //  }

    // Check if all fields in the current row are filled.
    const lastRow = newInputs[newInputs.length - 1];
    const areAllFieldsFilled =
      lastRow.contactName.trim() !== "" &&
      lastRow.contactEmail.trim() !== "" &&
      lastRow.contactPhonenumber.trim() !== "";

    // Add a new row only if all fields in the last row are filled.
    if (areAllFieldsFilled) {
      newInputs.push({
        contactName: "",
        contactEmail: "",
        contactPhonenumber: "",
      });
    }

    setSupplierContact(newInputs);
  };

  const Deletecontactinput = (id) => {
    const deleteData = supplierContact.filter((item, index) => index !== id);
    setSupplierContact(deleteData);
  };

  const checkEmailValidation = (e) => {
    const emailPattern = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;
    const emails = e.target.value;
    if (!emailPattern.test(emails) && emails.trim() !== "") {
      setValidemail(true);
    } else {
      setValidemail(false);
      setErrorfull(false);
    }
  };
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedContacts = Array.from(supplierContact);
    const [movedContact] = reorderedContacts.splice(result.source.index, 1);
    reorderedContacts.splice(result.destination.index, 0, movedContact);
    setSupplierContact(reorderedContacts);
  };

  // pagination for Contact start
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalItems = supplierContact?.length;
  const totalPages = Math.ceil(totalItems / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
  const handleCancel = () => {
    history.push("/supplier-list");
  };
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  // pagination for Contact end

  // pagination for Doc start
  const [paginationObj1, setPaginationObj1] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });
  const calculatePagination1 = useCallback(
    (pageNumber) => {
      const records = contactDocsList || [];
      const startRecordIndex = Math.max(10 * pageNumber - 9, 1);
      const endRecordIndex = Math.min(10 * pageNumber, records.length);
      const tempPaginationObj = {
        totalRecords: records.length,
        currentPage: pageNumber,
        startRecordIndex,
        endRecordIndex,
        totalPages: Math.ceil(records.length / 10),
        records: records.slice(startRecordIndex - 1, endRecordIndex),
      };
      setPaginationObj1({ ...tempPaginationObj });
    },
    [contactDocsList],
  );
  useEffect(() => {
    calculatePagination1(1);
  }, [calculatePagination1, contactDocsList]);
  // pagination for Doc end

  const lockDocument = (item) => {
    const updatedFileList = paginationObj1?.records?.map((file) =>
      file.documentid === item.documentid
        ? { ...file, islocked: file.islocked ? 0 : 1 }
        : file,
    );
    setContactDocsList(updatedFileList);
    if (isUpdating) {
      const payload = {
        documentid: item.documentid,
        islocked: item.islocked ? 0 : 1,
      };
      dispatch(UpdateIslocked(payload));
    }
  };

  // ASC Drag Drop start
  const handleDragEnd = (data) => {
    // let tempDragData = Array.from(supplierContact);
    let tempDragData = [...supplierContact];
    let [source_Data] = tempDragData.splice(data.source.index, 1);
    tempDragData.splice(data.destination.index, 0, source_Data);
    setSupplierContact(tempDragData);

    // for finding Droppable ids and indexes
    let draggableId = data.draggableId;
    let destinationDropId = data.destination.droppableId;
    let destinationIndex = data.destination.index;
    let sourceDropId = data.source.droppableId;
    let sourceIndex = data.source.index;

    // finding nearbyID using index
    let id22 = data.destination.index;
    let nearbyID = supplierContact.filter((item, index) => index === id22);

    // for sending in API below
    const originalIndexPosition = tempDragData.map((item, index) => ({
      ...item,
      oldIndexPosition: item.indexPosition,
      NewIndexPosition: index, // Updating indexPosition after drag
    }));

    const onlyUpdatedTasks = originalIndexPosition.filter((item, index) => {
      return item.oldIndexPosition !== item.NewIndexPosition;
    });

    const payload = onlyUpdatedTasks.map((item) => {
      return {
        supplierContactid: item.supplierContactid,
        indexPosition: item.NewIndexPosition,
      };
    });

    dispatch(UpdateSupplierContactIndexPositions(payload));
  };
  // ASC Drag Drop end
  const [pinCodeForAdress, setPinCodeForAdress] = useState("");

  // postal Code start
  const handleAddressSelect = (address) => {
    const { place_id } = address;
    geocodeByPlaceId(place_id)
      .then((res) => {
        console.log("Found the Address", res);

        if (res && res[0] && res[0].address_components) {
          const { long_name: postalCode = "" } =
            res[0].address_components.find((c) =>
              c.types.includes("postal_code"),
            ) || {};
          // setPinCodeForAdress(postalCode);

          if (!address.description.includes(postalCode)) {
            // setPinCodeForAdress(postalCode);
          }

          const { formatted_address, address_components } = res[0];
          setAddress(formatted_address);
        }
      })
      .catch((err) => {
        console.log("Error while fetching address meta ", err);
      })
      .finally((done) => {
        console.log("Address API Call Completed ", done);
      });
  };
  // postal Code end

  // supplier Email already exist
  useEffect(() => {
    if (isTypeEmail) {
      dispatch(SupplierEmailValidation({ supplieremail: email }));
    }
  }, [dispatch, email]);

  const [isValueExists, setIsValueExists] = useState(false);

  useEffect(() => {
    if (
      supplierEmailExistOrNotRes.status === true ||
      singleContactResponse?.status === true
    ) {
      if (
        email &&
        email === supplierEmailExistOrNotRes?.data?.email &&
        email !== singleContactResponse?.data?.data[0]?.email
      ) {
        setIsValueExists(true);
      } else {
        setIsValueExists(false);
      }
    } else {
      setIsValueExists(false);
    }
  }, [supplierEmailExistOrNotRes, singleContactResponse]);

  return (
    <>
      <SupplierHeader suppliername={headerscreenname} />

      {loading ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <section className="main-add-contact">
          <div className="ps-4 pe-4">
            <Row>
              <Col xl={8} lg={8} md={6} sm={12}></Col>
              <Col xl={4} lg={4} md={6} sm={12} className="add-col-item ">
                <div
                  className="d-flex cancel_cont_btn d-none d-sm-flex" // Show on larger screens, hide on small screens
                  onClick={() => {
                    handelCancel();
                  }}
                  style={{ borderRadius: "12px" }}
                >
                  <p className="fw-bold mb-0" style={{ color: "#5b5b5b" }}>
                    {/* Cancel */}
                    {t("Cancel")}
                  </p>
                </div>
                {removeaddbtn ? (
                  <div
                    className="d-flex add-buttons ms-4 d-none d-sm-flex" // Show on larger screens, hide on small screens
                    style={{ borderRadius: "12px" }}
                    onClick={handlesupplierAdd}
                  >
                    <p className="fw-bold mb-0">
                      {/* {isUpdating ? "Change" : "Add"} */}
                      {isUpdating ? t("Update") : t("Add")}
                    </p>
                  </div>
                ) : (
                  <div
                    className="d-flex add-buttons ms-4 d-none d-sm-flex" // Show on larger screens, hide on small screens
                    style={{ borderRadius: "12px" }}
                    onClick={handlesupplierAdd}
                  >
                    <p className="fw-bold mb-0">
                      {/* {isUpdating ? "Change" : "Add"} */}
                      {isUpdating ? t("Update") : t("Add")}
                    </p>
                  </div>
                )}
              </Col>
            </Row>
          </div>
          <div className="generalBox">
            <div className="textfiledbox">
              <div className="textfieldContent">
                <div className="row mobilegap tabletgap">
                  <div className="col-sm-4 col-md-6 col-lg-4 position-relative">
                    <div className={"inputBoxContent"}>
                      <div className="labelBox">
                        <label
                          className={errorfull ? "labelTextErr" : "labelText"}
                        >
                          {/* Name */}
                          {t("Name")}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <input
                        value={suppliername}
                        onFocus={() => setTouched(true)}
                        className={
                          errorfull
                            ? "inputBoxContentErrmsg"
                            : "inputItemtopfiled"
                        }
                        onChange={(e) => {
                          setSuppliername(e.target.value);
                          setErrorfull(false);
                          if (e.target.value !== "") {
                            dispatch(FetchSearchSupplier(e.target.value));
                          } else {
                            setShowSupplierBox(false);
                          }
                        }}
                        required
                        // placeholder={errorfull ? "" : "Supplier Name"}
                        placeholder={errorfull ? "" : t("Supplier Name")}
                        type="text"
                      />
                    </div>
                    <div className={errorfull ? "errmsg" : "errmsghide"}>
                      {/* Enter a name */}
                      {t("Enter a name")}
                    </div>
                    {showSupplierBox && (
                      <div
                        ref={refSupplierDropdownContainer}
                        className="supplier-box d-none"
                      >
                        {SerchSupplierData?.map((items, i) => {
                          return (
                            <>
                              {loadSwitchsupplier ? (
                                <p
                                  key={i}
                                  className="ps-2 pe-2 supplier-name pb-0 mb-0"
                                  onClick={() => {
                                    setShowSupplierBox(false);
                                    setsupplierfilterid(items?.supplierid);
                                    setSupplierExistPopup(true);
                                    setSearchSupplierData([]);
                                  }}
                                >
                                  {items?.suppliername}
                                </p>
                              ) : (
                                <p
                                  key={i}
                                  className="ps-2 pe-2 supplier-name pb-0 mb-0"
                                  onClick={() => {
                                    setShowSupplierBox(false);
                                    setsupplierfilterid(items?.supplierid);
                                    setSupplierExistPopup(true);
                                  }}
                                >
                                  {items?.suppliername}
                                </p>
                              )}
                            </>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-5 col-lg-4">
                    <div className={"inputBoxContent"} style={{ width: "97%" }}>
                      <div className="labelBox">
                        <label
                          className={validemail ? "labelTextErr" : "labelText"}
                        >
                          {/* Email */}
                          {t("Email")}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <input
                        onFocus={() => setTouched(true)}
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setIsTypeEmail(true);
                          checkEmailValidation(e);
                        }}
                        className={
                          validemail
                            ? "inputBoxContentErrmsg"
                            : "inputItemtopfiled"
                        }
                        placeholder={validemail ? "" : t("Supplier Email")}
                        type="email"
                      />
                    </div>
                    {isValueExists && (
                      <div className="errmsg">
                        This Email already exists
                        {/* {FetchTranslationList[66]?.translation} */}
                      </div>
                    )}
                    <div className={validemail ? "errmsg" : "errmsghide"}>
                      {/* Enter a valid email */}
                      {t("Enter a valid email")}
                    </div>
                  </div>

                  <div className="col-sm-3 col-md-12 col-lg-4">
                    {/* <div className="inputBoxContent" style={{ width: "80%" }}>
                      <div className="labelBox">
                        <label className="labelText">
                        
                          {FetchTranslationList[17]?.translation}
                        </label>
                      </div>
                      <input
                        type="tel"
                        value={phonenumber}
                        onChange={(e) => {
                          setPhonenumber(e.target.value);
                        }}
                        className="inputItemtopfiled"
                        onFocus={() => setTouched(true)}
                      />
                    </div> */}

                    <div
                      className="asc-input-container-supplier col-12"
                      id="ascInput"
                    >
                      <label className="asc-label-top projectNameText">
                        {/* Telephone */}
                        {t("Telephone")}
                      </label>
                      <PhoneInput
                        country={"nl"}
                        enableSearch={true}
                        className="contactDeliveryInput  pt-1 company-address "
                        // placeholder="Telephone Number"
                        placeholder={t("Telephone Number")}
                        value={phonenumber}
                        onChange={setPhonenumber}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section className="ps-4 pe-4">
              {!docAdded ? (
                <div className="column-2-info-supplier">
                  <div className="information-tabs-supplier">
                    <div
                      style={
                        activeHeading === "1"
                          ? { color: `${primaryColor}` }
                          : {}
                      }
                      className={
                        activeHeading === "1"
                          ? "tab-headings-supplier-active active-tab-heading responsive-font-14"
                          : "tab-headings-supplier responsive-font-14"
                      }
                      onClick={() => setActiveHeading("1")}
                    >
                      {/* General */}
                      {t("General ")}
                      {activeHeading === "1" && (
                        <div
                          className="tab-underline-supplier"
                          style={
                            activeHeading === "1"
                              ? { backgroundColor: `${primaryColor}` }
                              : {}
                          }
                        ></div>
                      )}
                    </div>
                    <div
                      style={
                        activeHeading === "2"
                          ? { color: `${primaryColor}` }
                          : {}
                      }
                      className={
                        activeHeading === "2"
                          ? "tab-headings-supplier-active active-tab-heading responsive-font-14"
                          : "tab-headings-supplier responsive-font-14"
                      }
                      onClick={() => setActiveHeading("2")}
                    >
                      {/* Contacts */}
                      {t("Contacts")}
                      {activeHeading === "2" && (
                        <div
                          className="tab-underline-supplier"
                          style={
                            activeHeading === "2"
                              ? { backgroundColor: `${primaryColor}` }
                              : {}
                          }
                        ></div>
                      )}
                    </div>
                    <div
                      style={
                        activeHeading === "3"
                          ? { color: `${primaryColor}` }
                          : {}
                      }
                      className={
                        activeHeading === "3"
                          ? "tab-headings-supplier-active active-tab-heading responsive-font-14"
                          : "tab-headings-supplier responsive-font-14"
                      }
                      onClick={() => setActiveHeading("3")}
                    >
                      {/* Documents */}
                      {t("Documents ")}
                      {activeHeading === "3" && (
                        <div
                          className="tab-underline-supplier"
                          style={
                            activeHeading === "3"
                              ? { backgroundColor: `${primaryColor}` }
                              : {}
                          }
                        ></div>
                      )}
                    </div>
                  </div>
                  <div></div>
                  {activeHeading === "1" && (
                    <div className="doc-block">
                      <div className="pt-4">
                        <div className="textfieldContent">
                          <div className="row">
                            <div className="col-sm-4 generalBoxMain">
                              <div className="inputboxwidth">
                                <div className="inputBoxContent generalTabTextField componentA-container">
                                  <div
                                    style={{
                                      position: "relative",
                                      borderRadius: "5px",
                                      border: "1px solid #70707080",
                                      padding: "10px",
                                    }}
                                  >
                                    <label
                                      style={{
                                        position: "absolute",
                                        top: "-10px",
                                        left: "10px",
                                        color: "#7E7E7E",
                                        backgroundColor: "#fff",
                                        padding: "0 5px",
                                      }}
                                    >
                                      {/* Address */}
                                      {t("Address")}
                                    </label>
                                    <GooglePlacesAutocomplete
                                      debounce={800}
                                      renderInput={(props) => (
                                        <textarea
                                          style={{
                                            border: "none",
                                            width: "100%",
                                            overflow: "hidden",
                                          }}
                                          {...props}
                                          rows={4}
                                          placeholder=""
                                        />
                                      )}
                                      onSelect={(e) => {
                                        setTouched(true);
                                        setAddress(e.description);
                                        handleAddressSelect(e);
                                      }}
                                      initialValue={address}
                                      placeholder=""
                                    />
                                  </div>
                                </div>

                                <div className="inputBoxContent generalTabTextField">
                                  <div className="labelBox">
                                    <label className="labelText">
                                      {/* Website */}
                                      {t("Website")}
                                    </label>
                                  </div>
                                  <input
                                    className="contacttabinput"
                                    value={website}
                                    onChange={(e) => {
                                      setWebsite(e.target.value);
                                    }}
                                    onFocus={() => setTouched(true)}
                                    type="text"
                                    // placeholder="www.example.com"
                                    placeholder={t("www.example.com")}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-sm-4 generalBoxMain">
                              <div className="inputboxwidth">
                                <div className="inputBoxContent generalTabTextField">
                                  <div className="labelBox">
                                    <label className="labelText">
                                      {/* VAT Number */}
                                      {t("VAT Number")}
                                    </label>
                                  </div>
                                  <input
                                    className="contacttabinput"
                                    onFocus={() => setTouched(true)}
                                    value={vatNumber}
                                    onChange={(e) => {
                                      setvatNumber(e.target.value);
                                    }}
                                    type="text"
                                  />
                                </div>

                                <div className="inputBoxContent generalTabTextField">
                                  <div className="labelBox">
                                    <label className="labelText">
                                      {/* IBAN */}
                                      {t("IBAN")}
                                    </label>
                                  </div>
                                  <input
                                    className="contacttabinput"
                                    onChange={(e) => {
                                      setIban(e.target.value);
                                    }}
                                    onFocus={() => setTouched(true)}
                                    value={iban}
                                    type="text"
                                  />
                                </div>

                                <div className="inputBoxContent generalTabTextField">
                                  <div className="labelBox">
                                    <label className="labelText">
                                      {/* Payment Conditions */}
                                      {t("Payment Conditions")}
                                    </label>
                                  </div>
                                  <input
                                    onFocus={() => setTouched(true)}
                                    className="contacttabinput"
                                    type="text"
                                    value={paymentconditions}
                                    onChange={(e) => {
                                      setPaymentconditions(e.target.value);
                                    }}
                                    placeholder={t("30 Days Credit")}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-sm-4 generalBoxMain">
                              <div>
                                <div className="inputBoxContent">
                                  <div className="notesBox">
                                    <label className="labelText">
                                      {/* Notes */}
                                      {t("Notes")}
                                    </label>
                                  </div>
                                  <textarea
                                    onFocus={() => setTouched(true)}
                                    rows={"8"}
                                    cols={"6"}
                                    value={notes}
                                    onChange={(e) => {
                                      setNotes(e.target.value);
                                    }}
                                    type="text"
                                    className="contacttabinput textarearbox"
                                    style={{ resize: "auto" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeHeading === "2" && (
                    <div className="doc-block">
                      {/* pagination for contact start */}
                      <div className="stock-custom-pagination py-3">
                        <div>
                          {startIndex + 1} - {endIndex + 1} of {totalItems}
                        </div>
                        <div className="pagination-buttons">
                          <div
                            className={`update-stock-pagination-button ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                            onClick={() => handlePageChange(currentPage - 1)}
                          >
                            <BsChevronLeft />
                          </div>
                          <div className="pagination-current-page">
                            {currentPage}
                          </div>
                          <div
                            className={`update-stock-pagination-button ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                            onClick={() => handlePageChange(currentPage + 1)}
                          >
                            <BsChevronRight />
                          </div>
                        </div>
                      </div>
                      {/* pagination for contact end */}
                      <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="ASCindex">
                          {(provider) => (
                            <div
                              className="textfieldContentwidthmobile"
                              ref={provider.innerRef}
                              {...provider.droppableProps}
                            >
                              {supplierContact
                                .slice(startIndex, endIndex + 1)
                                .map((item, index) => {
                                  const contactIndex = startIndex + index;
                                  return (
                                    <Draggable
                                      key={item.supplierContactid}
                                      draggableId={item.supplierContactid}
                                      index={index}
                                    >
                                      {(provider) => (
                                        <div
                                          key={contactIndex}
                                          {...provider.draggableProps}
                                          {...provider.dragHandleProps}
                                          ref={provider.innerRef}
                                        >
                                          <div className="documentContent">
                                            <div
                                              style={{
                                                fontSize: "1.3rem",
                                              }}
                                              onClick={() => {
                                                setTouched(true);
                                              }}
                                            >
                                              <img
                                                alt=""
                                                src={editIcon}
                                                style={{
                                                  width: "22px",
                                                  height: "20px",
                                                  marginRight: "0.25rem",
                                                }}
                                              />
                                            </div>

                                            <div className="contactBoxcontent">
                                              <div style={{ width: "30%" }}>
                                                <div className="inputBoxContent">
                                                  <div className="labelBox">
                                                    <label className="labelText">
                                                      {/* Name */}
                                                      {t("Name")}
                                                    </label>
                                                  </div>
                                                  <input
                                                    className="contacttabinput"
                                                    value={item.contactName}
                                                    name="contactName"
                                                    onChange={(e) => {
                                                      setTouched(true);
                                                      handleInputChange(
                                                        contactIndex,
                                                        "contactName",
                                                        e.target.value,
                                                      );
                                                    }}
                                                    type="text"
                                                    placeholder={t(
                                                      "Contact Name ",
                                                    )}
                                                  />
                                                </div>
                                              </div>

                                              <div style={{ width: "40%" }}>
                                                <div
                                                  className="inputBoxContent"
                                                  style={{
                                                    height: "55px",
                                                  }}
                                                >
                                                  <div className="labelBox">
                                                    <label
                                                      className={"labelText"}
                                                    >
                                                      {/* Email */}
                                                      {t("Email")}
                                                    </label>
                                                  </div>
                                                  <input
                                                    ref={(el) =>
                                                      (emailInputRefs.current[
                                                        contactIndex
                                                      ] = el)
                                                    }
                                                    className={
                                                      "contacttabinput"
                                                    }
                                                    type="email"
                                                    value={item.contactEmail}
                                                    name="contactEmail"
                                                    onChange={(e) => {
                                                      setTouched(true);
                                                      handleInputChange(
                                                        contactIndex,
                                                        "contactEmail",
                                                        e.target.value,
                                                      );
                                                    }}
                                                    placeholder={t(
                                                      "Contact Email",
                                                    )}
                                                  />
                                                  <div
                                                    style={{
                                                      height: "6px",
                                                    }}
                                                  >
                                                    {mailError?.[
                                                      contactIndex
                                                    ] && (
                                                      <div
                                                        style={{ color: "red" }}
                                                      >
                                                        {/* Invalid email format */}
                                                        {t(
                                                          "Invalid email format",
                                                        )}
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>

                                              <div style={{ width: "20%" }}>
                                                {/* <div className="inputBoxContent">
                                                  <div className="labelBox">
                                                    <label className="labelText">
                                                     
                                                      {
                                                        FetchTranslationList[17]
                                                          ?.translation
                                                      }
                                                    </label>
                                                  </div>
                                                  <input
                                                    type="tel"
                                                    value={
                                                      item.contactPhonenumber
                                                    }
                                                    name="contactPhonenumber"
                                                    onChange={(e) => {
                                                      setTouched(true);
                                                      handleInputChange(
                                                        contactIndex,
                                                        "contactPhonenumber",
                                                        e.target.value
                                                      );
                                                    }}
                                                    className="contacttabinput"
                                                    placeholder={FetchTranslationList[17]
                                                      ?.translation}
                                                  />
                                                </div> */}
                                                <div
                                                  className="asc-input-container-supplier col-12"
                                                  id="ascInput"
                                                >
                                                  <label className="asc-label-top projectNameText">
                                                    {/* Telephone */}
                                                    {t("Telephone")}
                                                  </label>
                                                  <PhoneInput
                                                    country={"nl"}
                                                    enableSearch={true}
                                                    className="contactDeliveryInput  pt-1 company-address phone_box_supplier"
                                                    placeholder={
                                                      t("Telephone") ||
                                                      "Telephone Number"
                                                    }
                                                    value={
                                                      item.contactPhonenumber
                                                    }
                                                    onChange={(value) => {
                                                      setTouched(true);
                                                      handleInputChange(
                                                        contactIndex,
                                                        "contactPhonenumber",
                                                        value,
                                                      );
                                                    }}
                                                  />
                                                </div>
                                              </div>

                                              <div style={{ width: "10%" }}>
                                                {supplierContact.length > 1 &&
                                                  item.contactName !== "" &&
                                                  item.contactEmail !== "" &&
                                                  item.contactPhonenumber !==
                                                    "" && (
                                                    <div className="deleteicon">
                                                      <RiDeleteBinLine
                                                        className="deleteiconsize"
                                                        style={{
                                                          curosor: "pointer",
                                                        }}
                                                        onClick={() => {
                                                          setTouched(true);
                                                          Deletecontactinput(
                                                            index,
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                })}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  )}
                  {activeHeading === "3" && (
                    <div style={{ padding: "20px 34px", marginTop: "1rem" }}>
                      <div
                        className="pt-3"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="addDocuments">
                          <DocumentUploaderWithProgress
                            onUploaded={onFileUploaded}
                            maxSizeInMb={100}
                          >
                            <div className="d-flex align-items-center gap-2 cursor-pointer">
                              <div className="Addbuttonicon">
                                <label>+</label>
                              </div>
                              <div className="addDocumentstext">
                                {/* Add Document */}
                                {t("Add Document ")}
                              </div>
                            </div>
                          </DocumentUploaderWithProgress>
                        </div>
                        {/* pagination for Doc start */}
                        <div className="stock-custom-pagination">
                          <div>
                            {`${paginationObj1.startRecordIndex} - ${paginationObj1.endRecordIndex}  of  ${paginationObj1.totalRecords}`}
                          </div>
                          <div className="pagination-buttons">
                            <div
                              className={`update-stock-pagination-button ${
                                paginationObj1.currentPage === 1
                                  ? "disabled"
                                  : ""
                              }`}
                              onClick={() =>
                                calculatePagination1(
                                  paginationObj1.currentPage - 1,
                                )
                              }
                            >
                              <BsChevronLeft />
                            </div>
                            <div className="pagination-current-page">
                              {paginationObj1.currentPage}
                            </div>
                            <div
                              className={`update-stock-pagination-button ${
                                paginationObj1.totalPages === 0 ||
                                paginationObj1.totalPages ===
                                  paginationObj1.currentPage
                                  ? "disabled"
                                  : ""
                              }`}
                              onClick={() =>
                                calculatePagination1(
                                  paginationObj1.currentPage + 1,
                                )
                              }
                            >
                              <BsChevronRight />
                            </div>
                          </div>
                        </div>
                        {/* pagination for Doc end */}
                      </div>
                      <div
                        style={{ position: "relative" }}
                        ref={selectDragdoc}
                        onDrop={(e) => {
                          e.preventDefault();
                          setDragfilepage(false);
                          if (e.dataTransfer.types.includes("Files")) {
                            const droppedFiles = Array.from(
                              e.dataTransfer.files,
                            );
                            setTouched(true);

                            if (droppedFiles) {
                              docUploadDragfile(droppedFiles);
                            } else {
                              return;
                            }
                          }
                        }}
                        onDragLeave={(e) => {
                          setDragfilepage(false);
                        }}
                        onDragOver={(e) => {
                          setDragfilepage(true);
                          e.preventDefault();
                        }}
                      >
                        {Dragfilepage ? (
                          <div className="dragbox">
                            <div className="dragcontent">
                              <img
                                src={AddIcon}
                                className="suppliers-img"
                                alt="Suppliers"
                                height="100%"
                                width="100%"
                              />
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div
                              style={{
                                paddingTop: "20px",
                                paddingBottom: "6px",
                              }}
                            >
                              <div className="task-table-grid">
                                <div className="task-grid-lines-heading">
                                  {/* Actions */}
                                  {t("Actions")}
                                </div>
                                <div className="task-grid-lines-heading">
                                  {/* Document Name */}
                                  {t("Document Name")}
                                </div>
                                <div className="task-grid-lines-heading hide-on-mobile hide-on-tablet">
                                  {/* Size */}
                                  {t("Size")}
                                </div>
                                <div className="task-grid-lines-heading hide-on-mobile hide-on-tablet">
                                  {/* Date */}
                                  {t("Date")}
                                </div>
                                <div className="task-grid-lines-heading hide-on-mobile hide-on-tablet">
                                  {/* Uploaded By */}
                                  {t("Uploaded By")}
                                </div>
                              </div>
                            </div>

                            {paginationObj1?.records?.map((doc, index) => {
                              return (
                                <div
                                  className="task-table-grid"
                                  style={{ marginBottom: "8px" }}
                                  key={index}
                                >
                                  <div className="task-grid-lines-active">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "13px",
                                      }}
                                    >
                                      <img
                                        draggable="false"
                                        className={"products-and-parts-dltIcon"}
                                        style={{
                                          cursor:
                                            doc?.userId === userId ||
                                            doc?.islockedby?.userid ===
                                              userId ||
                                            roleId1 ===
                                              process.env.REACT_APP_IS_OWNER
                                              ? doc?.islocked
                                                ? "not-allowed"
                                                : "pointer"
                                              : "not-allowed",
                                          opacity: doc?.islocked ? "0.5" : "1",
                                        }}
                                        src={DeleteIcon}
                                        alt=""
                                        onClick={() => {
                                          if (
                                            !doc?.islocked &&
                                            (doc?.userId === userId ||
                                              doc?.islockedby?.userid ===
                                                userId ||
                                              roleId1 ===
                                                process.env.REACT_APP_IS_OWNER)
                                          ) {
                                            setDeleteRowData(doc);
                                            setDeleteDocument(true);
                                          }
                                        }}
                                      />
                                      <img
                                        draggable="false"
                                        style={{
                                          cursor:
                                            doc?.userId === userId ||
                                            doc?.islockedby?.userid ===
                                              userId ||
                                            roleId1 ===
                                              process.env.REACT_APP_IS_OWNER
                                              ? "pointer "
                                              : "not-allowed",
                                        }}
                                        className="products-and-parts-dltIcon"
                                        src={doc.islocked ? lockBlue : lockGrey}
                                        alt=""
                                        onClick={() => {
                                          if (
                                            doc?.userId === userId ||
                                            doc?.islockedby?.userid ===
                                              userId ||
                                            roleId1 ===
                                              process.env.REACT_APP_IS_OWNER
                                          ) {
                                            lockDocument(doc);
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="task-grid-lines task-main-line">
                                    <LightTooltip
                                      title={doc?.filename || doc?.documentname}
                                      placement="top-start"
                                    >
                                      <div
                                        onMouseOver={() => {
                                          if (
                                            doc?.filename?.length > 30 ||
                                            doc?.documentname.length > 30
                                          ) {
                                            setFulLenghtDocAddContact(true);
                                          }
                                        }}
                                        onMouseOut={() => {
                                          setFulLenghtDocAddContact(false);
                                        }}
                                        style={{
                                          width: "14vw",
                                          cursor: "pointer",
                                          color: "#323232",
                                          fontWeight: "400",
                                        }}
                                        className="truncated-text1"
                                        onClick={(e) => {
                                          if (isUpdating) {
                                            handleDownloadContact(
                                              e,
                                              doc?.documentid,
                                              doc.documentname,
                                            );
                                          }
                                        }}
                                      >
                                        {" "}
                                        {doc?.filename || doc?.documentname}
                                      </div>
                                    </LightTooltip>
                                  </div>

                                  <div className="task-grid-lines task-main-line hide-on-mobile hide-on-tablet">
                                    {roundFileSize(doc?.documentsize)}
                                  </div>
                                  <div className="task-grid-lines task-main-line hide-on-mobile hide-on-tablet">
                                    {moment(doc?.date).format("DD.MMM.YYYY")}
                                  </div>
                                  {isUpdating ? (
                                    <div className="task-grid-lines task-main-line hide-on-mobile hide-on-tablet">
                                      {doc?.uploadedbyfirstname + " "}{" "}
                                      {doc?.uploadedbylastname}
                                    </div>
                                  ) : (
                                    <div className="task-grid-lines task-main-line hide-on-mobile hide-on-tablet">
                                      {firstupname} {lastupname}
                                    </div>
                                  )}

                                  <div className="pointer">
                                    <EyeOutlined
                                      onClick={() => {
                                        setFilePreview(
                                          getFilePreview({
                                            // file: file, // local upload file
                                            url: doc.link,
                                            type: doc.link.split(".").pop(),
                                            name: doc.documentname,
                                          }),
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <FilePreviewModal
                          open={filePreview}
                          file={filePreview}
                          onClose={() => setFilePreview(null)}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="column-2-info-supplier">
                  <div
                    className="doc-heading"
                    style={{ margin: "2rem auto 0 auto" }}
                  >
                    <div>
                      <img
                        alt=""
                        style={{
                          width: "20px",
                          height: "20px",
                          marginRight: "0.25rem",
                        }}
                      />
                      <span
                        className="doc-heading-bold"
                        style={{ color: `${primaryColor}` }}
                      >
                        {/* new DOc */}
                        {t("new Doc")}
                      </span>
                    </div>
                    <div>
                      <AiOutlineCloseCircle
                        style={{
                          fontSize: "1.4rem",
                          color: "#707070",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setTouched(true);
                          setDocAdded(false);
                        }}
                      />
                    </div>
                  </div>
                  <div className="upload-new-doc">
                    <AiFillPlusCircle
                      style={{
                        color: `${primaryColor}`,
                        cursor: "pointer",
                        fontSize: "var(--responsive-font-18)",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        selectDoc.current.click();
                        setTouched(true);
                      }}
                    />
                    <input
                      type="file"
                      // accept=".doc,.pdf,.xls,.xlsx,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      name="doc"
                      id="doc"
                      onFocus={() => setTouched(true)}
                      style={{ display: "none" }}
                      ref={selectDoc}
                    />
                    <span
                      className="text-heading-styles"
                      style={{ fontSize: "14px" }}
                    >
                      {/* Upload a new Doc */}
                      {t("Upload a new Doc")}
                    </span>
                    <div className="underline-contact"></div>
                    <p style={{ margin: "1rem 0 0 0" }}>{fileName}</p>
                    <div className="lock-round"></div>
                    <span className="manage-text">
                      {/* Manage Access */}
                      {t("Manage Access")}
                    </span>
                  </div>
                  <div className="general-access">
                    <p className="view-edit" style={{ marginBottom: "2rem" }}>
                      {/* General Access to view & edit */}
                      {t("General Access to view & edit")}
                    </p>
                    <div
                      className="roles-options roles-options-contact"
                      style={{
                        width: "100%",
                        display: "grid",
                        gridTemplateColumns: "repeat(4,1fr)",
                      }}
                    >
                      <p
                        style={
                          roleId === "08da3f0d-0371-4dd3-8c86-e51222d56198"
                            ? {
                                backgroundColor: `${primaryColor}`,
                                fontSize: "18px",
                              }
                            : { backgroundColor: `#FFFFFF`, fontSize: "16px" }
                        }
                        className={
                          roleId === "08da3f0d-0371-4dd3-8c86-e51222d56198"
                            ? "role-single authorisation-roles active-role active-main"
                            : "role-single authorisation-roles "
                        }
                      >
                        {/* owner */}
                        {t(" owner")}
                      </p>
                      <p
                        style={
                          roleId === "08da3f0d-0371-4dd3-8c86-e51222d56199"
                            ? {
                                backgroundColor: `${primaryColor}`,
                                fontSize: "18px",
                              }
                            : { backgroundColor: ``, fontSize: "16px" }
                        }
                        className={
                          roleId === "08da3f0d-0371-4dd3-8c86-e51222d56199"
                            ? "role-single authorisation-roles active-role active-main"
                            : "role-single authorisation-roles "
                        }
                      >
                        {/* manager */}
                        {t("manager")}
                      </p>
                      <p
                        style={
                          roleId === "08da3f0d-0371-4dd3-8c86-e51222d56200"
                            ? {
                                backgroundColor: `${primaryColor}`,
                                fontSize: "18px",
                              }
                            : { backgroundColor: ``, fontSize: "16px" }
                        }
                        className={
                          roleId === "08da3f0d-0371-4dd3-8c86-e51222d56200"
                            ? "role-single authorisation-roles active-role active-main"
                            : "role-single authorisation-roles "
                        }
                      >
                        {/* user */}
                        {t("user")}
                      </p>
                      <p
                        style={
                          roleId === "08da3f0d-0371-4dd3-8c86-e51222d56201"
                            ? {
                                backgroundColor: `${primaryColor}`,
                                fontSize: "18px",
                              }
                            : { backgroundColor: ``, fontSize: "16px" }
                        }
                        className={
                          roleId === "08da3f0d-0371-4dd3-8c86-e51222d56201"
                            ? "role-single authorisation-roles active-role active-main"
                            : "role-single authorisation-roles "
                        }
                      >
                        {/* freelancer */}
                        {t("freelancer")}
                      </p>
                    </div>
                  </div>
                  <div className="people-access general-access">
                    <p className="view-edit">People with access</p>
                    {docAccessList?.map((access, index) => {
                      return (
                        <div className="people-owner-flex">
                          <div className="image-name-flex">
                            <img
                              alt=""
                              src={access?.photo}
                              style={{ width: "35px", height: "35px" }}
                            />
                            <span className="name-flex">
                              <span>{access?.username}</span>
                              <span className="text-heading-styles">
                                {companyId ===
                                  "28830f30-b321-4662-a576-f23451677733" &&
                                  "Corporat Booking Desk"}
                                {companyId ===
                                  "28830f30-b321-4662-a576-f23451677744" &&
                                  "ZUID BEHEER"}
                                {companyId ===
                                  "28830f30-b321-4662-a576-f23451677755" &&
                                  "Residence 32"}
                              </span>
                            </span>
                          </div>
                          <div>
                            <select
                              key={index}
                              style={{ fontsize: "14px", width: "8rem" }}
                              className="input-style add-contact-input-style"
                              name="accesslevelid"
                              id="accesslevelid"
                              onFocus={() => setTouched(true)}
                              value={access.accesslevelid}
                              required
                            >
                              <option
                                value="08da33e9-5a64-4f8c-8d88-49e4982df321"
                                name="08da33e9-5a64-4f8c-8d88-49e4982df321"
                              >
                                {/* View */}
                                {t("View")}
                              </option>
                              <option
                                value="08da33e9-5a64-4f8c-8d88-49e4982df320"
                                name="08da33e9-5a64-4f8c-8d88-49e4982df320"
                              >
                                {/* Edit */}
                                {t("Edit")}
                              </option>
                              <option
                                value="08da33e9-5a64-4f8c-8d88-49e4982df323"
                                name="08da33e9-5a64-4f8c-8d88-49e4982df323"
                              >
                                {/* Owner */}
                                {t(" owner")}
                              </option>
                              <option
                                value="08da33e9-5a64-4f8c-8d88-49e4982df322"
                                name="08da33e9-5a64-4f8c-8d88-49e4982df322"
                              >
                                {t("NA")}
                              </option>
                            </select>
                          </div>
                        </div>
                      );
                    })}
                    <div className="plus-icon-function">
                      <div className="plus-icon">
                        <AiOutlinePlus
                          onClick={() => {
                            setTouched(true);
                            setShowDropPeople(!showDropPeople);
                          }}
                          style={{
                            fontSize: "1.5rem",
                            marginTop: "4px",
                            color: "#A7A7A7",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                      {showDropPeople && (
                        <div className="drop-down-plus" id="drop-down-plus">
                          <div class="search-div-people">
                            <input
                              type="text"
                              style={
                                searchPeople
                                  ? { opacity: "100%" }
                                  : { opacity: "50%" }
                              }
                              className="search-people-input"
                              placeholder="Search"
                              value={searchPeople}
                              onFocus={() => setTouched(true)}
                              onChange={(e) => {
                                setSearchPeople(e.target.value);
                              }}
                            />
                          </div>
                          {docPeopleList?.map((people, index) => {
                            const singlePeople = people.userdetails[0];
                            return (
                              <div key={index} className="peoples-flex">
                                <img
                                  alt=""
                                  src={singlePeople.imageurl}
                                  style={{ width: "30px", height: "30px" }}
                                />
                                <p style={{ marginBottom: "0" }}>
                                  {singlePeople.firstname}{" "}
                                  {singlePeople.lastname}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>
          <div className="ps-4 pe-4">
            <Row>
              <Col xl={9} lg={8} md={6} sm={12}></Col>
              <Col
                xl={3}
                lg={4}
                md={6}
                sm={12}
                className="add-col-item "
                style={{ marginTop: "3%", justifyContent: "center" }}
              >
                <div
                  className="d-flex cancel_cont_btn d-sm-none d-block" // Hide on larger screens, show on small screens
                  onClick={() => {
                    handelCancel();
                  }}
                  style={{ borderRadius: "12px" }}
                >
                  <p className="fw-bold mb-0" style={{ color: "#5b5b5b" }}>
                    {/* Cancel */}
                    {t("Cancel")}
                  </p>
                </div>
                {removeaddbtn ? (
                  <div
                    className="d-flex add-buttons ms-4 d-sm-none d-block" // Hide on larger screens, show on small screens
                    style={{ borderRadius: "12px" }}
                    onClick={handlesupplierAdd}
                  >
                    <p className="fw-bold mb-0">
                      {/* {isUpdating ? "Change" : "Add"} */}
                      {isUpdating ? t("Update") : t("Add")}
                    </p>
                  </div>
                ) : (
                  <div
                    className="d-flex add-buttons ms-4 d-sm-none d-block" // Hide on larger screens, show on small screens
                    style={{ borderRadius: "12px" }}
                    onClick={handlesupplierAdd}
                  >
                    <p className="fw-bold mb-0">
                      {/* {isUpdating ? "Change" : "Add"} */}
                      {isUpdating ? t("Update") : t("Add")}
                    </p>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </section>
      )}

      {popups && (
        <CancelWarningModal
          show={popups}
          onHide={() => setPopups(false)}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={Touched}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (Touched) {
            if (!["/supplier-list"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />

      {supplierExistPopup && (
        <Modal
          show={supplierExistPopup}
          className="modelwidth12 modal-dialog1"
          style={{
            backgroundColor: "transparent",
            opacity: 0.9,
          }}
          id="update-member-modal"
          centered
        >
          <Modal.Body>
            <div className="flex_class my-5">
              <div
                className=" "
                style={{ color: "#333333", fontSize: "14px", fontWeight: 700 }}
              >
                {/* This Supplier is already in the system */}
                {t("This Supplier is already in the system")}
              </div>

              <div
                className=" mt-4"
                style={{ color: "#333333", fontSize: "14px", fontWeight: 700 }}
              >
                {/* Do you want to proceed? */}
                {t("Do you want to proceed?")}
              </div>

              <div className="mt-5 ">
                <button
                  className="me-2 w-25 btn-no"
                  onClick={() => {
                    setSupplierExistPopup(false);

                    // window.location.reload();
                  }}
                >
                  {/* No */}
                  {t("Yes")}
                </button>
                <button
                  className="ms-2 w-25 btn-yes"
                  onClick={() => {
                    setSupplierExistPopup(false);
                    history.replace(
                      `/supplierlist/add-supplier/${supplierfilterid}`,
                    );
                    dispatch(FetchSuppliertById(supplierfilterid));
                    // history.push("/add-supplier");
                  }}
                >
                  {/* Add */}
                  {t("Add")}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          // title1={"This data will be removed from the system"}
          // title2={"and cannot be undone."}
          // title3={"Do you want to proceed?"}
          // no={"No"}
          // yes={"Yes"}
          title1={t("This data will be removed from the system")}
          title2={t("and cannot be undone.")}
          title3={t("Do you want to proceed?")}
          no={t("No")}
          yes={t("Yes")}
        />
      )}
    </>
  );
};

export default Addsupplier;
